import type * as React from 'react';
import { slot, useTabList_unstable } from '@fluentui/react-components';
import type {
  GroundingCommandBarTabListProps,
  GroundingCommandBarTabListState,
} from './GroundingCommandBarTabList.types';
import { GroundingCommandBarOverflowMenu } from '../GroundingCommandBarOverflowMenu';

// If you add JSX to this file, be sure to change the file type to .tsx

/**
 * Create the state required to render GroundingCommandBarTabList.
 *
 * The returned state can be modified with hooks such as useGroundingCommandBarTabListStyles_unstable,
 * before being passed to renderGroundingCommandBarTabList_unstable.
 *
 * @param props - props from this instance of GroundingCommandBarTabList
 * @param ref - reference to root HTMLElement of GroundingCommandBarTabList
 */
export const useGroundingCommandBarTabList_unstable = (
  props: GroundingCommandBarTabListProps,
  ref: React.Ref<HTMLDivElement>,
): GroundingCommandBarTabListState => {
  const { children, onTabSelect, overflowPadding = 0, minimumVisible = 0 } = props;

  const { components, ...tabListState } = useTabList_unstable({ appearance: 'subtle-circular', ...props }, ref);

  return {
    overflowPadding,
    minimumVisible,
    components: { ...components, overflowMenu: GroundingCommandBarOverflowMenu },
    ...tabListState,
    overflowMenu: slot.optional(props.overflowMenu, {
      defaultProps: { children, onTabSelect },
      renderByDefault: true,
      elementType: GroundingCommandBarOverflowMenu,
    }),
  };
};
